module.exports = __webpack_public_path__ + "img/feautured_product-placeholder.5bef87e.png";